import { acpSurveyAppStates } from './states';

export default (appModule) => {
  appModule.config(acpSurveyAppStates);
};
